import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { useTranslation } from 'react-i18next'
import homeIcon from '../../assets/new-left-menu/home.svg'
import iconPatient from '../../assets/new-left-menu/patients.svg'
import iconQuery from '../../assets/new-left-menu/consultas.svg'
import iconNews from '../../assets/new-left-menu/news.svg'
import iconResources from '../../assets/new-left-menu/resources.svg'
import iconMedicines from '../../assets/new-left-menu/icon-medicine.svg'
import iconCalendar from '../../assets/new-left-menu/calendar-act.svg'
import iconStadistics from '../../assets/new-left-menu/statistics.svg'
import iconTraining from '../../assets/new-left-menu/training.svg'
import iconForms from '../../assets/new-left-menu/forms.svg'

import styles from './ListItems.module.css'
import { ILoggedUserService } from '../../modules/users/services/LoggedUserService'
import { LOGGED_USER_SERVICE_KEY } from '../../modules/users'
import { getUserContainer } from '../../container/user-module'
import {
  ROUTE_MEDICINES,
  ROUTE_ARTICLES,
  ROUTE_CALENDAR,
  ROUTE_FORM_GENERATOR,
  ROUTE_MESSENGER,
  ROUTE_NEWS_WALL,
  ROUTE_PATIENT_FORMS,
  ROUTE_PATIENTS,
  ROUTE_RESOURCES,
  ROUTE_STATISTICS,
  ROUTE_TRAINING,
  ROUTE_TRAININGS,
} from 'routes/routes-constants'

import { useUserRoles } from 'modules/users/hooks/useUserRoles'

interface ItemProps {
  url: string
  label: string
  handle: string
  icon: string
  alt: string
  visible: boolean
}

type ListItemsProps = {
  handleClick: (type: string) => void
  isOpen: boolean
  setOpen: (b: boolean) => void
}

const userContainer = getUserContainer()
const loggedUserService = userContainer.get<ILoggedUserService>(LOGGED_USER_SERVICE_KEY)

const ListItems = (props: ListItemsProps) => {
  const { t } = useTranslation()
  const loggedUser = loggedUserService.get()
  const pathname = window.location.pathname

  const {
    isPatient,
    canAccessHome,
    canViewPatients,
    // canViewQueries,
    // canViewNews,
    // canViewResources,
    canAccessCalendarMenu,
    canManageMedicines,
    canAccessStatisticsMenu,
    canAccessTrainingMenu,
    canAccessTrainingCatalog,
    canAccessForms,
  } = useUserRoles(loggedUser)

  const trainingUrl = canAccessTrainingCatalog ? ROUTE_TRAININGS : ROUTE_TRAINING

  const ITEMS: ItemProps[] = [
    {
      label: t('start'),
      url: ROUTE_NEWS_WALL,
      handle: 'START',
      icon: homeIcon,
      alt: 'News Wall Icon',
      visible: canAccessHome,
    },
    {
      label: t('patients'),
      url: ROUTE_PATIENTS,
      handle: 'PATIENTS',
      icon: iconPatient,
      alt: 'Patients Icon',
      visible: canViewPatients,
    },
    // {
    //   label: t('queries'),
    //   url: ROUTE_MESSENGER,
    //   handle: 'QUERIES',
    //   icon: iconQuery,
    //   alt: 'Messenger Icon',
    //   visible: canViewQueries,
    // },
    // {
    //   label: t('news'),
    //   url: ROUTE_ARTICLES,
    //   handle: 'NEWS',
    //   icon: iconNews,
    //   alt: 'News Icon',
    //   visible: canViewNews,
    // },
    // {
    //   label: t('resources2'),
    //   url: ROUTE_RESOURCES,
    //   handle: 'RESOURCES',
    //   icon: iconResources,
    //   alt: 'Resources Icon',
    //   visible: canViewResources,
    // },
    {
      label: t('calendar'),
      url: ROUTE_CALENDAR,
      handle: 'SURVEYS',
      icon: iconCalendar,
      alt: 'Calendar Icon',
      visible: canAccessCalendarMenu,
    },
    {
      label: t('medicines'),
      url: ROUTE_MEDICINES,
      handle: 'MEDICINES',
      icon: iconMedicines,
      alt: 'Medicines Icon',
      visible: canManageMedicines,
    },
    {
      label: t('statistics'),
      url: ROUTE_STATISTICS,
      handle: 'STATISTICS',
      icon: iconStadistics,
      alt: 'Statistics Icon',
      visible: canAccessStatisticsMenu,
    },
    {
      label: t('training'),
      url: trainingUrl,
      handle: 'TRAINING',
      icon: iconTraining,
      alt: 'Training Icon',
      visible: canAccessTrainingMenu,
    },
    {
      label: t('forms'),
      url: isPatient ? ROUTE_PATIENT_FORMS : ROUTE_FORM_GENERATOR,
      handle: 'FORM-GENERATOR',
      icon: iconForms,
      alt: 'Forms Icon',
      visible: canAccessForms,
    },
  ]

  return (
    <List className={styles.listContainer}>
      {ITEMS.filter((item) => item.visible).map((item: ItemProps) => {
        const isActive = item.url.includes(pathname)

        return (
          <ListItemButton
            key={item.label}
            className={styles.listItem}
            onClick={() => props.handleClick(item.handle)}
          >
            <ListItemIcon className={styles.iconLayer}>
              <img
                className={`${styles.icon} ${isActive && styles.iconActive}`}
                src={item.icon}
                alt={item.alt}
              />
            </ListItemIcon>
            <ListItemText
              className={`${styles.text} ${isActive && styles.textActive}`}
              primary={item.label}
            />
          </ListItemButton>
        )
      })}
    </List>
  )
}

export default ListItems
